import { useEffect } from "react";
import { useTranslation } from "react-i18next";

/**
 * Drop this hook once in App.js (top level).
 * It updates document.title whenever the language changes.
 */
export default function useDocumentTitle() {
  const { t, i18n } = useTranslation();

  useEffect(() => {
    document.title = t("app.title");
  }, [i18n.language, t]);
}